// Initialize appInsights stub to prevent errors if SDK fails to load
if (typeof appInsights === 'undefined') {
    window.appInsights = {
        trackEvent: function() {},
        flush: function() {},
        trackPageView: function() {}
    };
}

class AzSearchBar extends HTMLElement {
    constructor() {
        super();

        this.searchInput = this.querySelector(".az-search-bar-input");
        this.searchList = this.querySelector(".az-predict-search-list");
        this.popularProductsDropdown = this.querySelector(".az-popular-products-search");
        this.serachForm = this.querySelector("#az-search-bar-form");
        this.searchListItemTemplatePrompt = this.querySelector("#az-search-list-prompt-template");
        this.searchListItemTemplateProduct = this.querySelector("#az-search-list-product-template");
        this.searchListNoItemTemplate = this.querySelector("#az-search-list-no-item-template");
        this.searchInputLabel = this.querySelector(".az-search-bar-input-label");
        this.popularSearchs = this.querySelectorAll(".az-popular-search-list-prompts");
        this.seachProductCards = this.querySelectorAll(".az-search-bar-product-card");

        // this.baseURL = "http://localhost:8000";
        // this.baseURL = "https://e1cf83c88b36.ngrok-free.app";
        this.baseURL = "https://app.getatomz.com";
        // this.baseURL = "https://searchserviceappstaging-fubxf4b6hvh4dxfr.canadacentral-01.azurewebsites.net";

        this.initialSetup();
    }

    safeTrackEvent(eventName, properties) {
        if (typeof appInsights !== 'undefined' && appInsights.trackEvent) {
            appInsights.trackEvent({
                name: eventName,
                properties: properties
            });
            appInsights.flush();
        }
    }

    initialSetup() {
        this.searchInput.addEventListener("focus", this.openSearchList.bind(this));
        this.searchInput.addEventListener("input", this.debounce(this.loadPredictiveSearch.bind(this), 200));
        this.serachForm.addEventListener('submit', this.handleSubmit.bind(this));

        setTimeout(() => {
            
        }, 100);

        this.shop = window.Shopify.shop;
        this.timeOffset = this.dataset.timeOffset;
        this.pageTemplate = this.dataset.pageTemplate;
        this.predictionDisbled = this.dataset.predictionDisabled;
        this.predictCache = {};
        this.boundCloseSearchList = this.closeSearchList.bind(this);
        this.searchSubmitted = false;

        if (this.pageTemplate == "search") {
            this.searchEvent = new CustomEvent("formSubmitted", { detail: { searchQuery: "" } });
            this.searchInput.value = this.getQueryParam('q');
        }
        else if (this.pageTemplate == "product" && this.getQueryParam('source') == "az-search") {
            document.addEventListener("DOMContentLoaded", () => {
                const journey = sessionStorage.getItem("atomz.ai");
                document.querySelectorAll('form[action="/cart/add"]').forEach(element => {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = "attributes[_app_source]";
                    hiddenInput.value = `atomz_search`;
                    element.appendChild(hiddenInput);

                    const productHandle = decodeURIComponent(window.location.pathname.split("/").pop());
                    const searchHistory = journey + ` -> ${this.storeTimeFromUTC()}, product '${productHandle}'`;
                    const hiddenSearchHistory = document.createElement("input");
                    hiddenSearchHistory.type = "hidden";
                    hiddenSearchHistory.name = `attributes[_journey_${this.dataset.productId}_${productHandle}]`;
                    hiddenSearchHistory.value = searchHistory;
                    element.appendChild(hiddenSearchHistory);
                });
                sessionStorage.setItem("atomz.ai", `${journey} -> ${window.location.pathname}`);
            });
        } else {
            sessionStorage.setItem("atomz.ai", window.location.pathname == "/" ? "/home" : window.location.pathname);
        }

        this.popularSearchs.forEach((li) => {
            li.addEventListener("click", () => {
                this.safeTrackEvent("InSearchSuggestionPromptClicked", {
                    promptText: li.querySelector(".az-popular-search-list-text").textContent,
                    storeName: this.shop
                });
                setTimeout(() => {
                    this.handlePredictionSubmit(li.querySelector(".az-popular-search-list-text").textContent);
                }, 300);
            });
        });

        this.seachProductCards.forEach((card) => {
            card.addEventListener("click", (event) => {
                event.preventDefault();
                this.safeTrackEvent("InSearchProductClicked", {
                    productTitle: card.querySelector(".az-search-bar-product-card-title").textContent,
                    storeName: this.shop
                });
                setTimeout(() => {
                    window.location.href = card.href;
                }, 300);
            });
        });
    }

    storeTimeFromUTC(offsetStr = this.timeOffset) {
        const sign = offsetStr[0];
        const hours = parseInt(offsetStr.substring(1, 3), 10);
        const minutes = parseInt(offsetStr.substring(3, 5), 10);
        let offsetMs = hours * 3600 * 1000 + minutes * 60 * 1000;
        if (sign === '-') {
            offsetMs = -offsetMs;
        }

        const nowUtc = Date.now();
        const targetTime = new Date(nowUtc + offsetMs);
        return targetTime.toISOString().replace("Z", "");
    }

    debounce(func, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    }

    openSearchList() {
        this.searchSubmitted = false;
        if (this.searchInput.value == '') {
            this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
        } else {
            this.loadPredictiveSearch();
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
        }
        document.addEventListener("click", this.boundCloseSearchList);
    }

    closeSearchList(event) {
        if (!this.searchInput.contains(event.target)) {
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
            this.searchInput.blur();
            document.removeEventListener("click", this.boundCloseSearchList);
        }
    }

    toggleListDisplay(openElement, closeElement, closeBoth = false) {
        if (closeBoth) {
            openElement.style.display = "none";
            openElement.style.opacity = "0";
        } else {
            openElement.style.display = "grid";
            openElement.style.opacity = "1";
        }
        closeElement.style.display = "none";
        closeElement.style.opacity = "0";
    }

    async loadPredictiveSearch() {
        if (this.predictCache[this.searchInput.value] && this.searchInput.value != '') {
            this.showPredictions(this.predictCache[this.searchInput.value]);
        } else if (this.searchInput.value == '') {
            this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
        } else {
            if (this.predictionDisbled == "true") {
                this.showPredictions(null);
            }
            else {
                try {
                    // search/suggest.json?q=${this.searchInput.value}&resources[type]=query
                    const response = await fetch(`${this.baseURL}/search-service/query-auto-complete`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ 'user_query': this.searchInput.value, 'shop': this.shop })
                    });

                    const predictions = await response.json();
                    this.showPredictions(predictions);
                    this.predictCache[this.searchInput.value] = predictions;
                } catch (error) {
                    if (error.name !== "AbortError") {
                        console.error(`Error loading predictive suggestions:`, error);
                    }
                }
            }
        }
    }

    showPredictions(predictions) {
        this.searchList.innerHTML = '';
        if (!this.searchSubmitted) {
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
        }
        if (predictions == null || predictions.length == 0) {
            const div = this.searchListNoItemTemplate.content.cloneNode(true);
            div.querySelector(".az-predict-search-list-text").innerHTML = `Search For <b>"${this.searchInput.value}"</b>`;
            div.querySelector('.az-predict-search-list-item').addEventListener('click', () => { this.handlePredictionSubmit(this.searchInput.value); });
            this.searchList.appendChild(div);
        } else {
            let count = 0;
            const promptDiv = document.createElement("div");
            predictions.forEach((prediction) => {
                if (count > 12)
                    return;
                const promptList = prediction.discoveryPrompts;
                if (typeof promptList != "object")
                    return
                count++;


                const div = this.searchListItemTemplatePrompt.content.cloneNode(true);
                const prompt = promptList[this.getRandomNumber(promptList.length)];
                div.querySelector(".az-predict-search-list-text").textContent = prompt;
                div.querySelector('.az-predict-prompt').addEventListener('click', () => { this.handlePredictionSubmit(prompt); });
                // div.querySelector('.az-link').href = `/products/${prediction.handle}?source=az-search`;
                promptDiv.appendChild(div);
            })

            count = 0;
            const productDiv = document.createElement("div");
            productDiv.classList.add("az-perdict-search-product-grid");
            predictions.forEach((prediction) => {
                if (count > 7)
                    return;
                const promptList = prediction.discoveryPrompts;
                if (typeof promptList != "object")
                    return
                count++;

                const div = this.searchListItemTemplateProduct.content.cloneNode(true);
                div.querySelector(".az-predict-search-list-image").src = prediction.featuredMedia + "&width=100&height=100";
                div.querySelector(".az-predict-search-list-image-text").textContent = prediction.titleForSuggester;
                div.querySelector(".az-predict-search-list-image-price").textContent = `${this.formatMoney(prediction.price)}${this.dataset.productCardCurrencyCode == "true" ? " " + window.Shopify.currency.active : ""}`;
                if (prediction.compareAtPrice) {
                    div.querySelector(".az-predict-search-list-image-compare-at-price").textContent = `${this.formatMoney(prediction.compareAtPrice)}${this.dataset.productCardCurrencyCode == "true" ? " " + window.Shopify.currency.active : ""}`;
                }
                div.querySelector(".az-link").addEventListener("click", (event) => {
                    event.preventDefault();
                    this.safeTrackEvent("InSearchProductClicked", {
                        productTitle: prediction.titleForSuggester,
                        storeName: this.shop
                    });
                    setTimeout(() => {
                        window.location.href = `/products/${prediction.handle}?source=az-search`;
                    }, 300);
                });
                productDiv.appendChild(div);
            })

            this.searchList.appendChild(promptDiv);
            this.searchList.appendChild(productDiv);
        }
    }

    formatMoney(price) {
        if (price === null || price === undefined) {
            return ''
        };

        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(price * 100, this.dataset.productCardMoneyFormat == "default" ? window.Shopify.money_format : this.dataset.productCardMoneyFormat);
        } else {
            const formatted = this.formatMoneyCustom(price * 100, this.dataset.productCardMoneyFormat == "default" ? '${{ amount }}' : this.dataset.productCardMoneyFormat);
            if (formatted !== null) {
                return formatted;
            }
        }

        return (price).toLocaleString('en-US', {
            style: 'currency',
            currency: window.Shopify.currency.active
        });
    }

    formatMoneyCustom(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
            if (isNaN(number) || number == null) { return 0; }

            number = (number / 100.0).toFixed(precision);

            const parts = number.split('.');
            const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
            const centsPart = parts[1] ? (decimal + parts[1]) : '';

            return dollars + centsPart;
        }

        switch (format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            default:
                value = null;
                break;
        }

        if (value === null) {
            return null;
        }

        return format.replace(placeholderRegex, value);
    }

    getRandomNumber(max) {
        return Math.floor(Math.random() * max);
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.searchInput.value == '') {
            return;
        }

        const redirectResponse = await fetch(`${this.baseURL}/search-service/get-redirects`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'shop': this.shop,
                'query': this.searchInput.value
            })
        });
        const redirectResponseJson = await redirectResponse.json();

        if (redirectResponseJson) {
            window.location.href = redirectResponseJson;
        }

        if (this.pageTemplate == "search") {
            this.triggerEvent(this.searchInput.value);
            this.toggleListDisplay(this.searchList, this.popularProductsDropdown, true);
            setTimeout(() => {
                this.searchInput.blur();
            }, 0);
        } else {
            if (!redirectResponseJson)
                this.serachForm.submit();
        }
    }

    handlePredictionSubmit(word) {
        if (this.pageTemplate == "search") {
            this.triggerEvent(word);
            this.searchInput.value = word;
        } else {
            this.searchInput.value = word;
            this.serachForm.submit();
        }
    }

    triggerEvent(searchQuery) {
        this.searchSubmitted = true;
        this.searchEvent.detail.searchQuery = searchQuery;
        this.serachForm.dispatchEvent(this.searchEvent);
        this.updateQueryParam('q', searchQuery);
    }

    getQueryParam(param) {
        const urlObj = new URL(window.location.href);
        return urlObj.searchParams.get(param);
    }

    updateQueryParam(param, newVal) {
        const urlObj = new URL(window.location.href);
        urlObj.searchParams.set(param, newVal);
        window.history.replaceState(null, '', urlObj.toString());
    }
}

customElements.define('az-search-bar', AzSearchBar);

class AnimatedText extends HTMLElement {
    constructor() {
        super();
        this.text = this.dataset.text;
        if (this.text) {
            this.text = this.text.split(",");
            this.textElemet = this.querySelector("#animation-text");
            this.textElemet.addEventListener("animationiteration", this.changeText.bind(this));
            this.currentIndex = 1;
        }
    }

    changeText() {
        this.textElemet.innerHTML = this.text[this.currentIndex];
        this.currentIndex = (this.currentIndex + 1) % this.text.length;
    }
}

customElements.define('animate-text', AnimatedText);

// Application Insights initialization (loaded after class definitions)
!(function (cfg) { function e() { cfg.onInit && cfg.onInit(n) } var x, w, D, t, E, n, C = window, O = document, b = C.location, q = "script", I = "ingestionendpoint", L = "disableExceptionTracking", j = "ai.device."; "instrumentationKey"[x = "toLowerCase"](), w = "crossOrigin", D = "POST", t = "appInsightsSDK", E = cfg.name || "appInsights", (cfg.name || C[t]) && (C[t] = E), n = C[E] || function (g) { var f = !1, m = !1, h = { initialize: !0, queue: [], sv: "8", version: 2, config: g }; function v(e, t) { var n = {}, i = "Browser"; function a(e) { e = "" + e; return 1 === e.length ? "0" + e : e } return n[j + "id"] = i[x](), n[j + "type"] = i, n["ai.operation.name"] = b && b.pathname || "_unknown_", n["ai.internal.sdkVersion"] = "javascript:snippet_" + (h.sv || h.version), { time: (i = new Date).getUTCFullYear() + "-" + a(1 + i.getUTCMonth()) + "-" + a(i.getUTCDate()) + "T" + a(i.getUTCHours()) + ":" + a(i.getUTCMinutes()) + ":" + a(i.getUTCSeconds()) + "." + (i.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z", iKey: e, name: "Microsoft.ApplicationInsights." + e.replace(/-/g, "") + "." + t, sampleRate: 100, tags: n, data: { baseData: { ver: 2 } }, ver: undefined, seq: "1", aiDataContract: undefined } } var n, i, t, a, y = -1, T = 0, S = ["js.monitor.azure.com", "js.cdn.applicationinsights.io", "js.cdn.monitor.azure.com", "js0.cdn.applicationinsights.io", "js0.cdn.monitor.azure.com", "js2.cdn.applicationinsights.io", "js2.cdn.monitor.azure.com", "az416426.vo.msecnd.net"], o = g.url || cfg.src, r = function () { return s(o, null) }; function s(d, t) { if ((n = navigator) && (~(n = (n.userAgent || "").toLowerCase()).indexOf("msie") || ~n.indexOf("trident/")) && ~d.indexOf("ai.3") && (d = d.replace(/(\/)(ai\.3\.)([^\d]*)$/, function (e, t, n) { return t + "ai.2" + n })), !1 !== cfg.cr) for (var e = 0; e < S.length; e++)if (0 < d.indexOf(S[e])) { y = e; break } var n, i = function (e) { var a, t, n, i, o, r, s, c, u, l; h.queue = [], m || (0 <= y && T + 1 < S.length ? (a = (y + T + 1) % S.length, p(d.replace(/^(.*\/\/)([\w\.]*)(\/.*)$/, function (e, t, n, i) { return t + S[a] + i })), T += 1) : (f = m = !0, s = d, !0 !== cfg.dle && (c = (t = function () { var e, t = {}, n = g.connectionString; if (n) for (var i = n.split(";"), a = 0; a < i.length; a++) { var o = i[a].split("="); 2 === o.length && (t[o[0][x]()] = o[1]) } return t[I] || (e = (n = t.endpointsuffix) ? t.location : null, t[I] = "https://" + (e ? e + "." : "") + "dc." + (n || "services.visualstudio.com")), t }()).instrumentationkey || g.instrumentationKey || "", t = (t = (t = t[I]) && "/" === t.slice(-1) ? t.slice(0, -1) : t) ? t + "/v2/track" : g.endpointUrl, t = g.userOverrideEndpointUrl || t, (n = []).push((i = "SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details)", o = s, u = t, (l = (r = v(c, "Exception")).data).baseType = "ExceptionData", l.baseData.exceptions = [{ typeName: "SDKLoadFailed", message: i.replace(/\./g, "-"), hasFullStack: !1, stack: i + "\nSnippet failed to load [" + o + "] -- Telemetry is disabled\nHelp Link: https://go.microsoft.com/fwlink/?linkid=2128109\nHost: " + (b && b.pathname || "_unknown_") + "\nEndpoint: " + u, parsedStack: [] }], r)), n.push((l = s, i = t, (u = (o = v(c, "Message")).data).baseType = "MessageData", (r = u.baseData).message = 'AI (Internal): 99 message:"' + ("SDK LOAD Failure: Failed to load Application Insights SDK script (See stack for details) (" + l + ")").replace(/\"/g, "") + '"', r.properties = { endpoint: i }, o)), s = n, c = t, JSON && ((u = C.fetch) && !cfg.useXhr ? u(c, { method: D, body: JSON.stringify(s), mode: "cors" }) : XMLHttpRequest && ((l = new XMLHttpRequest).open(D, c), l.setRequestHeader("Content-type", "application/json"), l.send(JSON.stringify(s))))))) }, a = function (e, t) { m || setTimeout(function () { !t && h.core || i() }, 500), f = !1 }, p = function (e) { var n = O.createElement(q), e = (n.src = e, t && (n.integrity = t), n.setAttribute("data-ai-name", E), cfg[w]); return !e && "" !== e || "undefined" == n[w] || (n[w] = e), n.onload = a, n.onerror = i, n.onreadystatechange = function (e, t) { "loaded" !== n.readyState && "complete" !== n.readyState || a(0, t) }, cfg.ld && cfg.ld < 0 ? O.getElementsByTagName("head")[0].appendChild(n) : setTimeout(function () { O.getElementsByTagName(q)[0].parentNode.appendChild(n) }, cfg.ld || 0), n }; p(d) } cfg.sri && (n = o.match(/^((http[s]?:\/\/.*\/)\w+(\.\d+){1,5})\.(([\w]+\.){0,2}js)$/)) && 6 === n.length ? (d = "".concat(n[1], ".integrity.json"), i = "@".concat(n[4]), l = window.fetch, t = function (e) { if (!e.ext || !e.ext[i] || !e.ext[i].file) throw Error("Error Loading JSON response"); var t = e.ext[i].integrity || null; s(o = n[2] + e.ext[i].file, t) }, l && !cfg.useXhr ? l(d, { method: "GET", mode: "cors" }).then(function (e) { return e.json()["catch"](function () { return {} }) }).then(t)["catch"](r) : XMLHttpRequest && ((a = new XMLHttpRequest).open("GET", d), a.onreadystatechange = function () { if (a.readyState === XMLHttpRequest.DONE) if (200 === a.status) try { t(JSON.parse(a.responseText)) } catch (e) { r() } else r() }, a.send())) : o && r(); try { h.cookie = O.cookie } catch (k) { } function e(e) { for (; e.length;)!function (t) { h[t] = function () { var e = arguments; f || h.queue.push(function () { h[t].apply(h, e) }) } }(e.pop()) } var c, u, l = "track", d = "TrackPage", p = "TrackEvent", l = (e([l + "Event", l + "PageView", l + "Exception", l + "Trace", l + "DependencyData", l + "Metric", l + "PageViewPerformance", "start" + d, "stop" + d, "start" + p, "stop" + p, "addTelemetryInitializer", "setAuthenticatedUserContext", "clearAuthenticatedUserContext", "flush"]), h.SeverityLevel = { Verbose: 0, Information: 1, Warning: 2, Error: 3, Critical: 4 }, (g.extensionConfig || {}).ApplicationInsightsAnalytics || {}); return !0 !== g[L] && !0 !== l[L] && (e(["_" + (c = "onerror")]), u = C[c], C[c] = function (e, t, n, i, a) { var o = u && u(e, t, n, i, a); return !0 !== o && h["_" + c]({ message: e, url: t, lineNumber: n, columnNumber: i, error: a, evt: C.event }), o }, g.autoExceptionInstrumented = !0), h }(cfg.cfg), (C[E] = n).queue && 0 === n.queue.length ? (n.queue.push(e), n.trackPageView({})) : e(); })({
    src: "https://js.monitor.azure.com/scripts/b/ai.3.gbl.min.js",
    crossOrigin: "anonymous",
    cfg: {
        connectionString: "InstrumentationKey=5da77fca-8147-4536-83ef-33da0d56210f;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/;ApplicationId=d88ae381-04d1-4078-bb9b-ee8bd26ad13f",
        disableAjaxTracking: true
    }
});
